import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import Shop from "./views/Shop.vue";
import Brand from "./views/Brand.vue";
import About from "./views/About.vue";
import Resume from "./views/Resume.vue";

Vue.use(Router);

var pageTitle = 'Brittany Foster';
var pageName = 'description';
var pageContent = 'I am Brittany Foster, a UX Designer, and this is my portfolio.';

var myRoute = '/';

export default new Router({
  
    mode: 'hash',
    routes: [
        {
            path: myRoute,
            name: "home",
            component: Home,
            meta: {
                title: pageTitle,
                metaTags: [
                  {
                    name: pageName,
                    content: pageContent
                  }
                ]
            }
        },
        {
          path: myRoute + 'shop',
          name: "shop",
          component: Shop,
          meta: {
              title: pageTitle,
              metaTags: [
                {
                  name: pageName,
                  content: pageContent
                }
              ]
          }
        },
        {
          path: myRoute + 'brand',
          name: "brand",
          component: Brand,
          meta: {
              title: pageTitle,
              metaTags: [
                {
                  name: pageName,
                  content: pageContent
                }
              ]
          }
        },
        {
          path: myRoute + 'about',
          name: "about",
          component: About,
            meta: {
                title: pageTitle,
                metaTags: [
                  {
                    name: pageName,
                    content: pageContent
                  }
                ]
            }
          },
          {
            path: myRoute + 'resume',
            name: "resume",
            component: Resume,
            meta: {
                title: pageTitle,
                metaTags: [
                  {
                    name: pageName,
                    content: pageContent
                  }
                ]
            }
          },

  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition;
    } else {
        return { x: 0, y: 0 };
    }
}

});